import { useLayout } from '@hana/shell';
import { Invoice } from './Invoice';
import { InvoicePad } from './InvoicePad';
import { InvoicePhone } from './InvoicePhone';

/** iPad → một bảng 21 chứng từ (Mint-Invoice-iPad), điện thoại → thẻ + chi tiết (Mint-Invoice-Phone); còn lại giữ bảng Mint-Invoice. */
export function InvoiceRoute() {
  const layout = useLayout();
  return layout === 'phone' ? <InvoicePhone /> : layout === 'pad' ? <InvoicePad /> : <Invoice />;
}
